// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Unified Task Management types.
 * Collection: grc_tasks, grc_task_audit
 * Sprint 17.0.0: Unified Task Data Model & Backend Foundation
 */
/**
 * Valid status transitions map. Terminal statuses have no outgoing transitions.
 * Shared between backend enforcement and frontend UI validation.
 * Sprint 25.8.0: Exported so TaskBoardPage can enforce client-side transition rules.
 */
export const TASK_VALID_TRANSITIONS = {
    pending: ['in_progress', 'cancelled'],
    in_progress: ['completed', 'blocked', 'escalated', 'cancelled'],
    blocked: ['in_progress', 'cancelled'],
    escalated: ['in_progress', 'completed', 'cancelled'],
    completed: [],
    cancelled: [],
    overdue: [], // computed status, not stored
};
/** Terminal statuses that cannot transition to any other status. */
export const TASK_TERMINAL_STATUSES = ['completed', 'cancelled'];
export const TASK_SOURCE_KIND_FILTERS = [
    'manual',
    'module',
    'forseti_chat',
    'forseti_workflow_run',
];
//# sourceMappingURL=task-management.js.map